import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import TasksExecsListByAuthUser from '../../../../../components/Tasks/TasksExecsLists/TasksExecsListByAuthUser';

class MyFinishedTasksList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: `inProcessTasksList`,
      queryParamsStatic: {
        status: 1
      }
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <TasksExecsListByAuthUser
        reducerName={this.state.reducerName}
        queryParamsStatic={this.state.queryParamsStatic}
      />
    );
  }
}

export default withRouter(MyFinishedTasksList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/InProcessTasksList/InProcessTasksList.js